/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebsiteStatistic
 */
export interface WebsiteStatistic {
    /**
     * 
     * @type {Date}
     * @memberof WebsiteStatistic
     */
    fromDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof WebsiteStatistic
     */
    toDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof WebsiteStatistic
     */
    uniqueVisitors?: number;
    /**
     * 
     * @type {number}
     * @memberof WebsiteStatistic
     */
    visits?: number;
    /**
     * 
     * @type {number}
     * @memberof WebsiteStatistic
     */
    averageVisitTime?: number;
    /**
     * 
     * @type {number}
     * @memberof WebsiteStatistic
     */
    registrations?: number;
}

/**
 * Check if a given object implements the WebsiteStatistic interface.
 */
export function instanceOfWebsiteStatistic(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebsiteStatisticFromJSON(json: any): WebsiteStatistic {
    return WebsiteStatisticFromJSONTyped(json, false);
}

export function WebsiteStatisticFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebsiteStatistic {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fromDate': !exists(json, 'fromDate') ? undefined : (new Date(json['fromDate'])),
        'toDate': !exists(json, 'toDate') ? undefined : (new Date(json['toDate'])),
        'uniqueVisitors': !exists(json, 'uniqueVisitors') ? undefined : json['uniqueVisitors'],
        'visits': !exists(json, 'visits') ? undefined : json['visits'],
        'averageVisitTime': !exists(json, 'averageVisitTime') ? undefined : json['averageVisitTime'],
        'registrations': !exists(json, 'registrations') ? undefined : json['registrations'],
    };
}

export function WebsiteStatisticToJSON(value?: WebsiteStatistic | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fromDate': value.fromDate === undefined ? undefined : (value.fromDate.toISOString().substr(0,10)),
        'toDate': value.toDate === undefined ? undefined : (value.toDate.toISOString().substr(0,10)),
        'uniqueVisitors': value.uniqueVisitors,
        'visits': value.visits,
        'averageVisitTime': value.averageVisitTime,
        'registrations': value.registrations,
    };
}

